function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers, JSON, Object, String, alternativesValue, loading, planTypes, selectedVendor, validationMessage, validationType) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['plan_option'] = function(planType) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'block': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-checkbox", {
            "attrs": __vjadeStringifyAttrsIfObj({
              disabled: !$helpers.canCancelPlan(planType),
              checked: planTypes[planType],
            }),
            "on": {
              click: () => $helpers.updatePlanTypes(planType)
            },
            "class": {
              'plan-type-checkbox': true
            },
          }));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": Object.assign({}, {
              disabled: !$helpers.canCancelPlan(planType)
            }, {
              'plan-description': true
            }),
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("h2", {
              "class": {
                'field-title': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("" + (planType) + " Plan");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat($helpers.getPlanDescription(planType));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("mp-modal", {
        "attrs": __vjadeStringifyAttrsIfObj({
          closeable: false,
          open: $component.isAttributeEnabled(`open`),
          'confirm-button-label': `Confirm`,
          'confirm-button-disabled': loading,
        }),
        "class": {
          'cancel-modal': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-card-header': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-card-header-title': true
            },
          }, [__vjadeSafeCode($helpers.getModalHeader())]));;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'input-form': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'inner-wrapper': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((loading) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-spinner"));;
              return __jade_nodes
            }).call(this)) : ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'row': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(($attr(`request-type`) === `downgrade_type`) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Your account will remain active and will automatically be moved to a Free plan.");;
                  return __jade_nodes
                }).call(this)) : ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Users will maintain access to your organization for " + ($attr(`days-to-churn`)) + " days,");
                  __jade_nodes = __jade_nodes.concat("  after which it will be deleted.");
                  __jade_nodes = __jade_nodes.concat("  After " + ($attr(`days-to-churn`)) + " days, organization projects will be");
                  __jade_nodes = __jade_nodes.concat((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(" ");
                    __jade_nodes = __jade_nodes.concat((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("strong", (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat("permanently");;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this));
                    __jade_nodes = __jade_nodes.concat(" deleted.");;
                    return __jade_nodes
                  }).call(this));;
                  return __jade_nodes
                }).call(this)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat((!$attr(`is-mtu`)) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": Object.assign({}, {
                    disabled: $attr(`request-type`) !== `downgrade_type`
                  }, {
                    'row': true,
                    'plan-types-row': true
                  }),
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(jade_mixins['plan_option'].call(this, `events`));
                  __jade_nodes = __jade_nodes.concat(jade_mixins['plan_option'].call(this, `people`));
                  __jade_nodes = __jade_nodes.concat((validationType === `plan`) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        'always-show': true,
                        type: `error`
                      }),
                    }, [__vjadeSafeCode(validationMessage)]));;
                    return __jade_nodes
                  }).call(this)) : undefined);;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);
              __jade_nodes = __jade_nodes.concat(($helpers.shouldShowSurvey()) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'row': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'form-title': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("Reasons for cancellation (select all that apply):");;
                    return __jade_nodes
                  }).call(this).filter(Boolean))); /*  TODO @evnp HACK - some issue with mp-checkbox-list makes {'show-select-all': false} NOT work below */
                  __jade_nodes = __jade_nodes.concat(h("mp-checkbox-list", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      items: JSON.stringify($helpers.getReasonOptions()),
                      'show-select-all': 0,
                      'num-columns': 2,
                    }),
                    "on": {
                      clickItem: ev => $helpers.selectedReason(ev.detail.item)
                    },
                  }));
                  __jade_nodes = __jade_nodes.concat((validationType === `reason`) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        'always-show': true,
                        type: `error`
                      }),
                    }, [__vjadeSafeCode(validationMessage)]));;
                    return __jade_nodes
                  }).call(this)) : undefined);
                  __jade_nodes = __jade_nodes.concat(($helpers.shouldShowFeatureInput()) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'section': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'form-title': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat("What features were missing?");;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));
                      __jade_nodes = __jade_nodes.concat(h("mp-input", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          'type': 'textarea'
                        }),
                        "on": {
                          input: $helpers.updateFeatureInput
                        },
                        "class": {
                          'form-entry-textarea': true
                        },
                      }));
                      __jade_nodes = __jade_nodes.concat((validationType === `feature`) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                          "attrs": __vjadeStringifyAttrsIfObj({
                            'always-show': true,
                            type: `error`
                          }),
                        }, [__vjadeSafeCode(validationMessage)]));;
                        return __jade_nodes
                      }).call(this)) : undefined);;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this)) : undefined);
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'section': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'form-title': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat("What will you do for analytics going forward?");;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));
                    __jade_nodes = __jade_nodes.concat(h("mp-select", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        options: JSON.stringify($helpers.ANALYTICS_ALTERNATIVES),
                        'selected-option': alternativesValue,
                      }),
                      "on": {
                        change: $helpers.updateAlternatives
                      },
                      "class": {
                        'form-entry-dropdown': true
                      },
                    }));
                    __jade_nodes = __jade_nodes.concat((validationType === `analytics`) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          'always-show': true,
                          type: `error`,
                          placement: `right`
                        }),
                      }, [__vjadeSafeCode(validationMessage)]));;
                      return __jade_nodes
                    }).call(this)) : undefined);;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));
                  __jade_nodes = __jade_nodes.concat(($helpers.shouldShowVendor()) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'section': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'form-title': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat("Which vendor?");;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));
                      __jade_nodes = __jade_nodes.concat(h("mp-select", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          options: JSON.stringify($helpers.COMPETITORS),
                          'selected-option': selectedVendor,
                          'menu-height': 133,
                        }),
                        "on": {
                          change: $helpers.updateCompetitor
                        },
                        "class": {
                          'form-entry-dropdown': true
                        },
                      }));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this)) : undefined);
                  __jade_nodes = __jade_nodes.concat(($helpers.shouldShowVendorInput()) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'section': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'form-title': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat("Please enter the name of the vendor here:");;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));
                      __jade_nodes = __jade_nodes.concat(h("mp-input", {
                        "on": {
                          input: $helpers.updateVendorInput
                        },
                        "class": {
                          'form-entry-textarea': true
                        },
                      }));
                      __jade_nodes = __jade_nodes.concat((validationType === `vendor`) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                          "attrs": __vjadeStringifyAttrsIfObj({
                            'always-show': true,
                            type: `error`
                          }),
                        }, [__vjadeSafeCode(validationMessage)]));;
                        return __jade_nodes
                      }).call(this)) : undefined);;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this)) : undefined);
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'section': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'form-title': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat("Would you like to add anything else?");;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));
                    __jade_nodes = __jade_nodes.concat(h("mp-input", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        'type': 'textarea'
                      }),
                      "on": {
                        input: $helpers.updateAdditionalInfo
                      },
                      "class": {
                        'form-entry-textarea': true
                      },
                    }));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-modal-bottom-buttons': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-button", {
              "on": {
                click: $helpers.handleCancel
              },
              "class": {
                'mp-modal-button': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Cancel");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("mp-async-button", {
              "attrs": __vjadeStringifyAttrsIfObj({
                theme: `primary`
              }),
              "props": {
                asyncAction: $helpers.handleSubmit
              },
              "class": {
                'mp-modal-button': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Submit");;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "alternativesValue" in locals ? locals.alternativesValue : typeof alternativesValue !== "undefined" ? alternativesValue : undefined, "loading" in locals ? locals.loading : typeof loading !== "undefined" ? loading : undefined, "planTypes" in locals ? locals.planTypes : typeof planTypes !== "undefined" ? planTypes : undefined, "selectedVendor" in locals ? locals.selectedVendor : typeof selectedVendor !== "undefined" ? selectedVendor : undefined, "validationMessage" in locals ? locals.validationMessage : typeof validationMessage !== "undefined" ? validationMessage : undefined, "validationType" in locals ? locals.validationType : typeof validationType !== "undefined" ? validationType : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;